import { useFliptBoolean } from "@flipt-io/flipt-client-react";
import useUser from "~/contexts/user";

// Defaults to true — customers without this flag defined have unrestricted access.
// Set enabled: false with a segment in a customer's features.yaml to restrict access.
export const useWorkflowsAccessFlag = (): boolean => {
  const user = useUser();
  return useFliptBoolean("workflows-access", true, user?.email);
};

// Gates all worksheet-related features (nav access, column linking in pipeline creation, worksheet detail UI).
export const useWorksheetsFlag = () => {
  const user = useUser();
  return useFliptBoolean("worksheets", false, user?.email);
};

// Gates the ability to create new workflow submissions.
export const useWorkflowCreationFlag = () => {
  const user = useUser();
  return useFliptBoolean("workflow-creation", false, user?.email);
};

export const useSavedWorkflowFlag = () => {
  const user = useUser();
  return useFliptBoolean("saved-workflow", false, user?.email);
};

export const useCostTransparencyFlag = () => {
  const user = useUser();
  return useFliptBoolean("cost-transparency", false, user?.email);
};

export const useJamieCromwellLogoFlag = () => {
  const user = useUser();
  return useFliptBoolean("jamie-cromwell-logo", false, user?.email);
};
